import styled from 'styled-components';

const Style = styled.div`
  position: relative;

  .anticon-loading {
    font-size: 9px;
  }
  
  .table {
    display: flex;
    flex-direction: column;
    gap: var(--size-lg);

    .jus-c {
      justify-content: center;
    }

    h2 {
      font-size: 14px;
      font-weight: 400;
      color: #475467;
      margin-bottom: 0px;
    }

    .item {
      flex-wrap: wrap;
      display: flex;
      gap: 12px;

      img {
        width: 14px;
        margin-right: 12px;
      }

      .main {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
      }
    }
  }
`;

export default Style;
